(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  const initCartNote = () => {
    const cartPage = document.querySelector('.cart-page');
    const noteInput = document.querySelector('#cart-note');
    const cartUpdateUrl = cartPage?.dataset.cartUpdateUrl || '/cart/update.js';

    if (!noteInput) return;

    let savedNote = noteInput.value;

    const saveNote = async () => {
      if (noteInput.value === savedNote) return true;

      try {
        const response = await fetch(cartUpdateUrl, {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
          body: JSON.stringify({ note: noteInput.value }),
        });

        if (response.ok) {
          savedNote = noteInput.value;
          return true;
        }
      } catch (error) {
        // Note still submits with checkout if save fails.
      }

      return false;
    };

    noteInput.addEventListener('blur', saveNote);

    return saveNote;
  };

  const initCartQuantityControls = (saveNote) => {
    const cartPage = document.querySelector('.cart-page');
    const errorBanner = document.querySelector('[data-cart-errors]');
    const quantityButtons = document.querySelectorAll('[data-cart-quantity-change]');
    const cartChangeUrl = cartPage?.dataset.cartChangeUrl || '/cart/change.js';

    const showError = (message) => {
      if (!errorBanner) return;
      errorBanner.textContent = message;
      errorBanner.hidden = false;
      errorBanner.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    };

    quantityButtons.forEach((button) => {
      button.addEventListener('click', async () => {
        if (button.disabled) return;

        const line = button.dataset.line;
        const quantity = Number.parseInt(button.dataset.quantity || '0', 10);
        if (!line || Number.isNaN(quantity)) return;

        button.disabled = true;

        try {
          if (saveNote) {
            await saveNote();
          }

          const response = await fetch(cartChangeUrl, {
            method: 'POST',
            headers: {
              Accept: 'application/json',
              'Content-Type': 'application/json',
            },
            body: JSON.stringify({ id: line, quantity }),
          });

          if (response.ok) {
            window.location.reload();
            return;
          }

          const errorData = await response.json().catch(() => null);
          showError(errorData?.description || errorData?.message || errorBanner.dataset.defaultError);
        } catch (error) {
          showError(errorBanner.dataset.defaultError);
        } finally {
          button.disabled = false;
        }
      });
    });
  };

  const saveNote = initCartNote();
  initCartQuantityControls(saveNote);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  (() => {
    const filtersForm = document.querySelector('#shop-all-filters-form');
    const sortSelect = document.querySelector('#shop-all-sort-by');
    const dropdowns = document.querySelectorAll('[data-filter-dropdown]');
    const mobileDropdownBreakpoint = window.matchMedia('(max-width: 749px)');
    const mobileFiltersButton = document.querySelector('[data-mobile-filters-open]');
    const mobileFiltersSheet = document.querySelector('#shop-all-mobile-filters');
    const mobileFiltersSlot = document.querySelector('[data-mobile-filter-slot]');
    const filtersShell = document.querySelector('.shop-all-toolbar__filters-shell');
    const filtersContainer = document.querySelector('[data-shop-all-filters]');

    if (!filtersForm) {
      return;
    }

    const resetDropdownAlignment = (dropdown) => {
      dropdown.classList.remove('shop-all-filter-dropdown--align-right');
    };

    const positionDropdown = (dropdown) => {
      if (!mobileDropdownBreakpoint.matches) {
        resetDropdownAlignment(dropdown);
        return;
      }

      const trigger = dropdown.querySelector('[data-filter-dropdown-trigger]');
      const panel = dropdown.querySelector('[data-filter-dropdown-panel]');

      if (!trigger || !panel || panel.hidden) {
        return;
      }

      resetDropdownAlignment(dropdown);

      const triggerRect = trigger.getBoundingClientRect();
      const panelWidth = panel.offsetWidth;
      const viewportPadding = 8;
      const shouldAlignRight =
        triggerRect.left + panelWidth > window.innerWidth - viewportPadding && triggerRect.left > viewportPadding;

      if (shouldAlignRight) {
        dropdown.classList.add('shop-all-filter-dropdown--align-right');
      }
    };

    const setMobileFiltersOpen = (isOpen) => {
      if (!mobileFiltersButton || !mobileFiltersSheet) {
        return;
      }

      mobileFiltersButton.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
      mobileFiltersSheet.hidden = !isOpen;
      document.body.classList.toggle('shop-all-filters-open', isOpen);
    };

    const moveFiltersIntoSheet = () => {
      if (!filtersContainer || !mobileFiltersSlot || filtersContainer.parentElement === mobileFiltersSlot) {
        return;
      }

      mobileFiltersSlot.appendChild(filtersContainer);
    };

    const restoreFiltersToShell = () => {
      if (!filtersContainer || !filtersShell || filtersContainer.parentElement === filtersShell) {
        return;
      }

      filtersShell.appendChild(filtersContainer);
    };

    const openMobileFilters = () => {
      closeAllDropdowns();
      moveFiltersIntoSheet();
      setMobileFiltersOpen(true);
    };

    const closeMobileFilters = () => {
      setMobileFiltersOpen(false);
      restoreFiltersToShell();
      closeAllDropdowns();
    };

    const closeAllDropdowns = (exceptDropdown = null) => {
      dropdowns.forEach((dropdown) => {
        if (dropdown === exceptDropdown) {
          return;
        }

        const trigger = dropdown.querySelector('[data-filter-dropdown-trigger]');
        const panel = dropdown.querySelector('[data-filter-dropdown-panel]');

        if (!trigger || !panel) {
          return;
        }

        trigger.setAttribute('aria-expanded', 'false');
        panel.hidden = true;
        resetDropdownAlignment(dropdown);
      });
    };

    const toggleDropdown = (dropdown) => {
      const trigger = dropdown.querySelector('[data-filter-dropdown-trigger]');
      const panel = dropdown.querySelector('[data-filter-dropdown-panel]');

      if (!trigger || !panel) {
        return;
      }

      const isOpen = trigger.getAttribute('aria-expanded') === 'true';

      closeAllDropdowns();

      if (!isOpen) {
        trigger.setAttribute('aria-expanded', 'true');
        panel.hidden = false;
        window.requestAnimationFrame(() => {
          positionDropdown(dropdown);
        });
      }
    };

    dropdowns.forEach((dropdown) => {
      const trigger = dropdown.querySelector('[data-filter-dropdown-trigger]');

      if (!trigger) {
        return;
      }

      trigger.addEventListener('click', () => {
        toggleDropdown(dropdown);
      });
    });

    document.addEventListener('click', (event) => {
      if (event.target.closest('[data-filter-dropdown]')) {
        return;
      }

      closeAllDropdowns();
    });

    if (mobileFiltersButton && mobileFiltersSheet) {
      mobileFiltersButton.addEventListener('click', () => {
        const isOpen = mobileFiltersSheet.hidden === false;

        if (isOpen) {
          closeMobileFilters();
          return;
        }

        openMobileFilters();
      });

      mobileFiltersSheet.querySelectorAll('[data-mobile-filters-close]').forEach((element) => {
        element.addEventListener('click', closeMobileFilters);
      });
    }

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeMobileFilters();
        closeAllDropdowns();
      }
    });

    window.addEventListener('resize', () => {
      if (!mobileDropdownBreakpoint.matches) {
        closeMobileFilters();
      }

      dropdowns.forEach((dropdown) => {
        positionDropdown(dropdown);
      });
    });

    document.addEventListener('change', (event) => {
      if (
        event.target.form === filtersForm &&
        event.target.matches('input[type="checkbox"]') &&
        !mobileDropdownBreakpoint.matches
      ) {
        filtersForm.requestSubmit();
      }
    });

    if (sortSelect) {
      sortSelect.addEventListener('change', () => {
        filtersForm.requestSubmit();
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  document.querySelectorAll('[data-header-section-id]').forEach((headerElement) => {
    if (headerElement.dataset.mobileMenuReady === 'true') {
      return;
    }

    const drawer = headerElement.querySelector('[data-mobile-menu-root]');
    const openButton = headerElement.querySelector('[data-mobile-menu-open]');

    if (!drawer || !openButton) {
      return;
    }

    headerElement.dataset.mobileMenuReady = 'true';

    const closeButtons = drawer.querySelectorAll('[data-mobile-menu-close]');
    const navLinks = drawer.querySelectorAll('.header__mobile-nav a');
    const closeTransitionDuration = 250;

    const closeMenu = () => {
      drawer.classList.remove('is-open');
      openButton.setAttribute('aria-expanded', 'false');
      document.body.classList.remove('header-mobile-menu-open');
      window.setTimeout(() => {
        if (!drawer.classList.contains('is-open')) {
          drawer.hidden = true;
        }
      }, closeTransitionDuration);
    };

    const openMenu = () => {
      drawer.hidden = false;
      openButton.setAttribute('aria-expanded', 'true');
      document.body.classList.add('header-mobile-menu-open');
      requestAnimationFrame(() => {
        drawer.classList.add('is-open');
      });
    };

    openButton.addEventListener('click', openMenu);
    closeButtons.forEach((button) => {
      button.addEventListener('click', closeMenu);
    });
    navLinks.forEach((link) => {
      link.addEventListener('click', closeMenu);
    });
    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && drawer.classList.contains('is-open')) {
        closeMenu();
      }
    });
  });

  document.querySelectorAll('[data-header-section-id]').forEach((headerElement) => {
    const desktopHeader = headerElement.querySelector('.header__desktop');
    const megaMenuItem = headerElement.querySelector('[data-mega-menu]');
    const panel = headerElement.querySelector('[data-mega-menu-panel]');

    if (!desktopHeader || !megaMenuItem || !panel || megaMenuItem.dataset.megaMenuReady === 'true') {
      return;
    }

    const trigger = megaMenuItem.querySelector('[data-mega-menu-trigger]');

    if (!trigger) {
      return;
    }

    megaMenuItem.dataset.megaMenuReady = 'true';

    const inner = panel.querySelector('.shop-all-mega-menu__inner');
    const collectionUrl = panel.dataset.megaMenuCollectionUrl;
    const needsFetch = panel.dataset.megaMenuNeedsFetch === 'true';
    const sectionIdStorageKey = 'as-shop-all-mega-menu-section-id';
    const sectionIdPattern = /shopify-section-(template--\d+__shop_all_mega_menu)/;
    let fetchPromise = null;

    const getStoredSectionId = () => {
      try {
        return sessionStorage.getItem(sectionIdStorageKey);
      } catch (error) {
        return null;
      }
    };

    const storeSectionId = (sectionId) => {
      try {
        sessionStorage.setItem(sectionIdStorageKey, sectionId);
      } catch (error) {
        return;
      }
    };

    const injectMegaMenuInner = (sourceInner) => {
      if (!sourceInner || !inner) {
        return false;
      }

      inner.innerHTML = sourceInner.innerHTML;
      inner.dataset.megaMenuLoaded = 'true';
      panel.removeAttribute('aria-busy');
      return true;
    };

    const parseSectionHtml = (sectionHtml) => {
      const template = document.createElement('template');
      template.innerHTML = sectionHtml.trim();
      return template.content.querySelector('.shop-all-mega-menu__inner');
    };

    const fetchSectionHtml = (sectionId) => {
      return fetch(`${collectionUrl}?sections=${encodeURIComponent(sectionId)}`).then((response) => {
        if (!response.ok) {
          throw new Error(`Mega menu section fetch failed: ${response.status}`);
        }

        return response.json();
      });
    };

    const scrapeMegaMenuFromPage = () => {
      return fetch(collectionUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Mega menu page fetch failed: ${response.status}`);
          }

          return response.text();
        })
        .then((pageHtml) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(pageHtml, 'text/html');
          const sourceInner = doc.querySelector('.shop-all-mega-menu-api-source .shop-all-mega-menu__inner');

          if (injectMegaMenuInner(sourceInner)) {
            return;
          }

          throw new Error('Mega menu markup not found on collection page');
        });
    };

    const discoverSectionId = () => {
      return fetch(collectionUrl)
        .then((response) => {
          if (!response.ok) {
            throw new Error(`Mega menu discovery failed: ${response.status}`);
          }

          return response.text();
        })
        .then((pageHtml) => {
          const sectionIdMatch = pageHtml.match(sectionIdPattern);

          if (sectionIdMatch) {
            storeSectionId(sectionIdMatch[1]);
            return sectionIdMatch[1];
          }

          const parser = new DOMParser();
          const doc = parser.parseFromString(pageHtml, 'text/html');
          const sourceInner = doc.querySelector('.shop-all-mega-menu-api-source .shop-all-mega-menu__inner');

          if (injectMegaMenuInner(sourceInner)) {
            return null;
          }

          throw new Error('Mega menu section id not found');
        });
    };

    const loadMegaMenuContent = () => {
      if (!collectionUrl || !inner || inner.dataset.megaMenuLoaded === 'true') {
        return Promise.resolve();
      }

      if (fetchPromise) {
        return fetchPromise;
      }

      panel.setAttribute('aria-busy', 'true');

      fetchPromise = Promise.resolve(getStoredSectionId())
        .then((sectionId) => sectionId || discoverSectionId())
        .then((sectionId) => {
          if (!sectionId || inner.dataset.megaMenuLoaded === 'true') {
            return;
          }

          return fetchSectionHtml(sectionId).then((sections) => {
            const sectionHtml = Object.values(sections)[0];

            if (!sectionHtml) {
              throw new Error('Mega menu section response empty');
            }

            const fetchedInner = parseSectionHtml(sectionHtml);

            if (!injectMegaMenuInner(fetchedInner)) {
              throw new Error('Mega menu inner markup missing');
            }
          });
        })
        .catch(() => scrapeMegaMenuFromPage())
        .catch((error) => {
          fetchPromise = null;
          panel.removeAttribute('aria-busy');
          console.error(error);
        });

      return fetchPromise;
    };

    const scheduleIdlePrefetch = () => {
      const prefetch = () => {
        if (inner.dataset.megaMenuLoaded === 'true') {
          return;
        }

        loadMegaMenuContent();
      };

      if ('requestIdleCallback' in window) {
        requestIdleCallback(prefetch, { timeout: 4000 });
      } else {
        window.setTimeout(prefetch, 3000);
      }
    };

    if (needsFetch) {
      scheduleIdlePrefetch();
    }

    let closeTimeout = null;
    const closeDelay = 150;
    const hoverTargets = [megaMenuItem, panel];

    const openMegaMenu = () => {
      if (needsFetch) {
        loadMegaMenuContent();
      }
      if (closeTimeout) {
        window.clearTimeout(closeTimeout);
        closeTimeout = null;
      }

      desktopHeader.classList.add('is-mega-menu-open');
      panel.hidden = false;
      trigger.setAttribute('aria-expanded', 'true');
    };

    const closeMegaMenu = () => {
      closeTimeout = window.setTimeout(() => {
        desktopHeader.classList.remove('is-mega-menu-open');
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
      }, closeDelay);
    };

    hoverTargets.forEach((target) => {
      target.addEventListener('mouseenter', openMegaMenu);
      target.addEventListener('mouseleave', closeMegaMenu);
      target.addEventListener('focusin', openMegaMenu);
    });

    desktopHeader.addEventListener('focusout', (event) => {
      if (!desktopHeader.contains(event.relatedTarget)) {
        closeMegaMenu();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && desktopHeader.classList.contains('is-mega-menu-open')) {
        if (closeTimeout) {
          window.clearTimeout(closeTimeout);
          closeTimeout = null;
        }

        desktopHeader.classList.remove('is-mega-menu-open');
        panel.hidden = true;
        trigger.setAttribute('aria-expanded', 'false');
        trigger.focus();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    connectedCallback() {
      const url = this.dataset.url;
      if (!url) return;

      fetch(url)
        .then((response) => response.text())
        .then((text) => {
          const html = document.createElement('div');
          html.innerHTML = text;
          const recommendations = html.querySelector('product-recommendations');
          if (!recommendations || recommendations.innerHTML.trim() === '') return;
          this.innerHTML = recommendations.innerHTML;
        })
        .catch(() => {});
    }
  }

  if (!customElements.get('product-recommendations')) {
    customElements.define('product-recommendations', ProductRecommendations);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      const viewport = section.querySelector('.product-slider__scroll');
      const track = section.querySelector('.product-slider__track');
      const firstCard = section.querySelector('.product-slider__card');
      const prevBtn = section.querySelector('.product-slider__arrow--prev');
      const nextBtn = section.querySelector('.product-slider__arrow--next');

      if (!viewport || !track || !firstCard || !prevBtn || !nextBtn) return;
      if (viewport.dataset.emblaReady === 'true') return;
      viewport.dataset.emblaReady = 'true';

      const getStep = () => {
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      };

      const AUTO_PLAY_INTERVAL_MS = 4500;
      const AUTO_SCROLL_DURATION_MS = 850;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileMedia = window.matchMedia('(max-width: 749px)');
      const isMobileViewport = () => mobileMedia.matches;
      let autoPlayTimer = null;
      let animationFrameId = null;

      const syncArrows = () => {
        const atStart = viewport.scrollLeft <= 1;
        const atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
      };

      const easeInOutCubic = (progress) => {
        if (progress < 0.5) return 4 * progress * progress * progress;
        return 1 - Math.pow(-2 * progress + 2, 3) / 2;
      };

      const animateTo = (target) => {
        const start = viewport.scrollLeft;
        const distance = target - start;

        if (Math.abs(distance) < 1) {
          viewport.scrollLeft = target;
          syncArrows();
          return;
        }

        if (prefersReducedMotion) {
          viewport.scrollLeft = target;
          syncArrows();
          return;
        }

        if (animationFrameId !== null) {
          window.cancelAnimationFrame(animationFrameId);
          animationFrameId = null;
        }

        const startTime = performance.now();
        const step = (now) => {
          const elapsed = now - startTime;
          const progress = Math.min(1, elapsed / AUTO_SCROLL_DURATION_MS);
          const easedProgress = easeInOutCubic(progress);
          viewport.scrollLeft = start + distance * easedProgress;
          syncArrows();

          if (progress < 1) {
            animationFrameId = window.requestAnimationFrame(step);
            return;
          }

          animationFrameId = null;
          viewport.scrollLeft = target;
          syncArrows();
        };

        animationFrameId = window.requestAnimationFrame(step);
      };

      const scrollByStep = (direction) => {
        if (animationFrameId !== null) {
          window.cancelAnimationFrame(animationFrameId);
          animationFrameId = null;
        }
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const target = viewport.scrollLeft + direction * getStep();
        const clampedTarget = Math.max(0, Math.min(maxScroll, target));
        viewport.scrollTo({ left: clampedTarget, behavior: 'smooth' });
      };

      const scrollForwardByOneCard = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const nextTarget = viewport.scrollLeft + getStep();
        const isAtEnd = viewport.scrollLeft >= maxScroll - 1;
        const target = isAtEnd ? 0 : Math.min(maxScroll, nextTarget);
        animateTo(target);
      };

      const centerStart = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        if (maxScroll <= 0) return;

        if (isMobileViewport()) {
          const firstCardLeft = firstCard.offsetLeft;
          const cardWidth = firstCard.getBoundingClientRect().width;
          const centeredLeft = firstCardLeft - (viewport.clientWidth - cardWidth) / 2;
          viewport.scrollLeft = Math.max(0, Math.min(maxScroll, centeredLeft));
          return;
        }

        viewport.scrollLeft = maxScroll / 2;
      };

      const stopAutoplay = () => {
        if (autoPlayTimer === null) return;
        window.clearInterval(autoPlayTimer);
        autoPlayTimer = null;
      };

      const startAutoplay = () => {
        if (isMobileViewport()) return;
        if (prefersReducedMotion) return;
        if (autoPlayTimer !== null) return;
        autoPlayTimer = window.setInterval(() => {
          if (document.hidden) return;
          scrollForwardByOneCard();
        }, AUTO_PLAY_INTERVAL_MS);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      prevBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (prevBtn.disabled) return;
        scrollByStep(-1);
        restartAutoplay();
      });
      nextBtn.addEventListener('click', (e) => {
        e.preventDefault();
        if (nextBtn.disabled) return;
        scrollByStep(1);
        restartAutoplay();
      });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', (event) => {
        const nextFocusedElement = event.relatedTarget;
        if (nextFocusedElement && section.contains(nextFocusedElement)) return;
        startAutoplay();
      });
      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
          return;
        }
        startAutoplay();
      });

      const handleMobileBreakpointChange = () => {
        if (isMobileViewport()) {
          stopAutoplay();
          return;
        }
        startAutoplay();
      };

      mobileMedia.addEventListener('change', handleMobileBreakpointChange);

      requestAnimationFrame(() => {
        centerStart();
        syncArrows();
        startAutoplay();
      });
      viewport.addEventListener('scroll', syncArrows);
      syncArrows();
    };

    const run = () => {
      document.querySelectorAll('.product-slider').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (e) => {
      const section = e.target.querySelector('.product-slider');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  (() => {
    const initProductSection = (section) => {
      const canHoverZoom = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
      const gallery = section.querySelector('[data-gallery]');
      const viewerFrame = section.querySelector('.product-page__viewer-frame');
      const viewerImage = section.querySelector('[data-gallery-image]');
      const thumbs = section.querySelectorAll('[data-gallery-thumb]');
      const prevButton = section.querySelector('[data-gallery-prev]');
      const nextButton = section.querySelector('[data-gallery-next]');
      const quantityInput = section.querySelector('.product-page__quantity-input');
      const decreaseButton = section.querySelector('[data-quantity-decrease]');
      const increaseButton = section.querySelector('[data-quantity-increase]');

      if (canHoverZoom && viewerFrame && viewerImage) {
        viewerFrame.addEventListener('mousemove', (event) => {
          const rect = viewerFrame.getBoundingClientRect();
          const x = ((event.clientX - rect.left) / rect.width) * 100;
          const y = ((event.clientY - rect.top) / rect.height) * 100;
          viewerImage.style.transformOrigin = `${x}% ${y}%`;
        });

        viewerFrame.addEventListener('mouseleave', () => {
          viewerImage.style.transformOrigin = '50% 50%';
        });
      }

      if (gallery && viewerImage && thumbs.length > 1) {
        let activeIndex = 0;
        let loadToken = 0;

        const preloadedImages = Array.from(thumbs).map((thumb) => {
          const img = new Image();
          img.src = thumb.dataset.imageSrc || '';
          return img;
        });

        const updateGalleryUi = (clampedIndex) => {
          thumbs.forEach((item, itemIndex) => {
            const isActive = itemIndex === clampedIndex;
            item.classList.toggle('is-active', isActive);
            if (isActive) {
              item.setAttribute('aria-current', 'true');
              item.scrollIntoView({ block: 'nearest', inline: 'nearest', behavior: 'smooth' });
            } else {
              item.removeAttribute('aria-current');
            }
          });

          if (prevButton) {
            prevButton.disabled = clampedIndex === 0;
          }

          if (nextButton) {
            nextButton.disabled = clampedIndex === thumbs.length - 1;
          }
        };

        const waitForImage = (img) =>
          new Promise((resolve) => {
            if (img.complete) {
              resolve();
              return;
            }

            const done = () => {
              img.removeEventListener('load', done);
              img.removeEventListener('error', done);
              resolve();
            };

            img.addEventListener('load', done);
            img.addEventListener('error', done);
          });

        const showImage = async (clampedIndex, token) => {
          const thumb = thumbs[clampedIndex];
          const preload = preloadedImages[clampedIndex];

          await waitForImage(preload);

          if (token !== loadToken) return;

          viewerImage.src = thumb.dataset.imageSrc || '';
          viewerImage.srcset = thumb.dataset.imageSrcset || '';
          viewerImage.alt = thumb.dataset.imageAlt || '';
          viewerImage.style.transformOrigin = '50% 50%';

          if (viewerImage.decode) {
            try {
              await viewerImage.decode();
            } catch {
              // Ignore decode errors; the browser will still render the image.
            }
          }

          if (token !== loadToken) return;
        };

        const setActive = (index) => {
          const clampedIndex = Math.max(0, Math.min(thumbs.length - 1, index));
          activeIndex = clampedIndex;
          const token = ++loadToken;

          updateGalleryUi(clampedIndex);
          showImage(clampedIndex, token);
        };

        thumbs.forEach((thumb, index) => {
          thumb.addEventListener('click', () => {
            setActive(index);
          });
        });

        if (prevButton) {
          prevButton.addEventListener('click', () => {
            setActive(activeIndex - 1);
          });
        }

        if (nextButton) {
          nextButton.addEventListener('click', () => {
            setActive(activeIndex + 1);
          });
        }

        gallery.addEventListener('keydown', (event) => {
          if (event.key === 'ArrowLeft') {
            event.preventDefault();
            setActive(activeIndex - 1);
          } else if (event.key === 'ArrowRight') {
            event.preventDefault();
            setActive(activeIndex + 1);
          }
        });

        updateGalleryUi(0);
      }

      const isMobileMedia = window.matchMedia('(max-width: 749px)');
      const mediaSlider = section.querySelector('[data-media-slider]');
      const mediaItems = section.querySelectorAll('.product-page__media-item');
      const mediaDots = section.querySelectorAll('[data-slide-to]');

      if (mediaSlider && mediaItems.length > 1 && mediaDots.length === mediaItems.length) {
        const getSlideIndex = () => {
          if (mediaSlider.clientWidth <= 0) return 0;
          const index = Math.round(mediaSlider.scrollLeft / mediaSlider.clientWidth);
          return Math.max(0, Math.min(mediaItems.length - 1, index));
        };

        const setActiveDot = (index) => {
          mediaDots.forEach((dot, dotIndex) => {
            const isActive = dotIndex === index;
            dot.classList.toggle('is-active', isActive);
            if (isActive) {
              dot.setAttribute('aria-current', 'true');
            } else {
              dot.removeAttribute('aria-current');
            }
          });
        };

        const scrollToSlide = (index) => {
          const target = mediaItems[index];
          if (!target) return;
          mediaSlider.scrollTo({ left: target.offsetLeft, behavior: 'smooth' });
        };

        const syncDots = () => {
          if (!isMobileMedia.matches) return;
          setActiveDot(getSlideIndex());
        };

        mediaDots.forEach((dot) => {
          dot.addEventListener('click', () => {
            if (!isMobileMedia.matches) return;
            const index = Number.parseInt(dot.dataset.slideTo || '0', 10);
            if (Number.isNaN(index)) return;
            scrollToSlide(index);
          });
        });

        mediaSlider.addEventListener('scroll', syncDots, { passive: true });
        window.addEventListener('resize', syncDots);
        syncDots();
      }

      if (!quantityInput || !decreaseButton || !increaseButton) return;

      const limitNotice = section.querySelector('[data-quantity-limit-notice]');
      const productForm = section.querySelector('.product-page__form');
      const variantSelect = section.querySelector('.product-page__select[name="id"]');
      const submitButton = section.querySelector('.product-page__submit');
      const limitsScript = section.querySelector('[data-product-variant-limits]');
      const variantLimits = limitsScript ? JSON.parse(limitsScript.textContent) : [];
      const limitMessageTemplate =
        limitNotice?.dataset.limitMessage || 'Only __QTY__ available';

      const getVariantLimit = (variantId) => {
        const id = Number.parseInt(String(variantId), 10);
        return variantLimits.find((entry) => entry.id === id) || null;
      };

      const formatLimitMessage = (quantity) => limitMessageTemplate.replace('__QTY__', String(quantity));

      let activeLimit = getVariantLimit(variantSelect?.value || productForm?.querySelector('[name="id"]')?.value);

      const updateLimitNotice = (value, limit) => {
        if (!limitNotice || !limit) return;

        const hasPurchaseLimit = limit.limitQuantity < 9999;
        const atMax = hasPurchaseLimit && limit.maxQuantity > 0 && value >= limit.maxQuantity;
        const noneLeft = limit.maxQuantity === 0 && limit.canPurchase;

        if (atMax || noneLeft) {
          limitNotice.textContent = formatLimitMessage(limit.limitQuantity);
          limitNotice.hidden = false;
        } else {
          limitNotice.hidden = true;
        }
      };

      const applyQuantityRules = (limit, preserveValue = true) => {
        if (!limit) return;

        activeLimit = limit;
        const maxQuantity = limit.maxQuantity;

        if (maxQuantity > 0) {
          quantityInput.max = String(maxQuantity);
          quantityInput.min = '1';
          quantityInput.disabled = false;
          decreaseButton.disabled = false;

          let value = preserveValue ? Number.parseInt(quantityInput.value, 10) : 1;
          if (Number.isNaN(value) || value < 1) value = 1;
          if (value > maxQuantity) value = maxQuantity;
          quantityInput.value = String(value);
          increaseButton.disabled = value >= maxQuantity;
        } else {
          quantityInput.value = '0';
          quantityInput.removeAttribute('max');
          quantityInput.disabled = true;
          decreaseButton.disabled = true;
          increaseButton.disabled = true;
        }

        if (submitButton) {
          submitButton.disabled = !limit.canPurchase || maxQuantity === 0;
        }

        updateLimitNotice(Number.parseInt(quantityInput.value, 10) || 0, limit);
      };

      const clampValue = (value) => {
        const parsed = Number.parseInt(value, 10);
        const maxQuantity = activeLimit?.maxQuantity ?? Number.POSITIVE_INFINITY;
        if (Number.isNaN(parsed) || parsed < 1) return 1;
        if (maxQuantity > 0 && parsed > maxQuantity) return maxQuantity;
        return parsed;
      };

      const syncQuantityState = () => {
        const value = clampValue(quantityInput.value);
        quantityInput.value = String(value);

        if (activeLimit) {
          increaseButton.disabled = activeLimit.maxQuantity > 0 ? value >= activeLimit.maxQuantity : true;
          updateLimitNotice(value, activeLimit);
        }
      };

      decreaseButton.addEventListener('click', () => {
        quantityInput.value = clampValue(quantityInput.value) - 1;
        syncQuantityState();
      });

      increaseButton.addEventListener('click', () => {
        const nextValue = clampValue(quantityInput.value) + 1;
        const maxQuantity = activeLimit?.maxQuantity ?? Number.POSITIVE_INFINITY;

        if (maxQuantity > 0 && nextValue > maxQuantity) {
          syncQuantityState();
          return;
        }

        quantityInput.value = String(nextValue);
        syncQuantityState();
      });

      quantityInput.addEventListener('change', syncQuantityState);

      if (variantSelect) {
        variantSelect.addEventListener('change', () => {
          applyQuantityRules(getVariantLimit(variantSelect.value), false);
        });
      }

      if (productForm) {
        productForm.addEventListener('submit', (event) => {
          if (!activeLimit) return;

          const value = Number.parseInt(quantityInput.value, 10);
          if (activeLimit.maxQuantity === 0 || value > activeLimit.maxQuantity) {
            event.preventDefault();
            updateLimitNotice(value, activeLimit);
            limitNotice?.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
          }
        });
      }

      if (activeLimit) {
        applyQuantityRules(activeLimit);
      }
    };

    const run = () => {
      document.querySelectorAll('.product-page').forEach(initProductSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.product-page');
      if (section) initProductSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["rotating-banner"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initRotatingBanner = (section) => {
      const viewport = section.querySelector('[data-rotating-banner]');
      const slides = section.querySelectorAll('.rotating-banner__slide');
      const dots = section.querySelectorAll('.rotating-banner__dot');

      if (!viewport || slides.length === 0) return;
      if (viewport.dataset.rotatingBannerReady === 'true') return;
      viewport.dataset.rotatingBannerReady = 'true';

      const autoplayEnabled = section.dataset.autoplay === 'true';
      const autoplayIntervalMs =
        Number.parseFloat(getComputedStyle(section).getPropertyValue('--rotating-banner-autoplay-interval')) * 1000 ||
        5000;
      const prefersReducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      const mobileMedia = window.matchMedia('(max-width: 749px)');

      let autoPlayTimer = null;
      let autoPlayKickoffTimer = null;

      const getSlideIndex = () => {
        if (viewport.clientWidth <= 0) return 0;
        const index = Math.round(viewport.scrollLeft / viewport.clientWidth);
        return Math.max(0, Math.min(slides.length - 1, index));
      };

      const syncViewportHeight = () => {
        if (!mobileMedia.matches) {
          viewport.style.height = '';
          return;
        }

        const activeSlide = slides[getSlideIndex()];
        if (!activeSlide) return;
        viewport.style.height = `${activeSlide.offsetHeight}px`;
      };

      const setActiveDot = (index) => {
        dots.forEach((dot, dotIndex) => {
          const isActive = dotIndex === index;
          dot.classList.toggle('is-active', isActive);
          if (isActive) {
            dot.setAttribute('aria-current', 'true');
          } else {
            dot.removeAttribute('aria-current');
          }
        });
      };

      const scrollToSlide = (index, behavior = 'smooth') => {
        const clampedIndex = Math.max(0, Math.min(slides.length - 1, index));
        const target = slides[clampedIndex];
        if (!target) return;

        if (prefersReducedMotion) {
          viewport.scrollLeft = target.offsetLeft;
        } else {
          viewport.scrollTo({ left: target.offsetLeft, behavior });
        }

        setActiveDot(clampedIndex);
      };

      const scrollByDirection = (direction) => {
        const currentIndex = getSlideIndex();
        const nextIndex = currentIndex + direction;

        if (nextIndex >= slides.length) {
          scrollToSlide(0);
          return;
        }

        if (nextIndex < 0) {
          scrollToSlide(slides.length - 1);
          return;
        }

        scrollToSlide(nextIndex);
      };

      const syncDots = () => {
        setActiveDot(getSlideIndex());
        syncViewportHeight();
      };

      const stopAutoplay = () => {
        if (autoPlayTimer !== null) {
          window.clearInterval(autoPlayTimer);
          autoPlayTimer = null;
        }
        if (autoPlayKickoffTimer !== null) {
          window.clearTimeout(autoPlayKickoffTimer);
          autoPlayKickoffTimer = null;
        }
      };

      const startAutoplay = () => {
        if (!autoplayEnabled) return;
        if (prefersReducedMotion) return;
        if (slides.length <= 1) return;
        if (autoPlayTimer !== null) return;
        if (autoPlayKickoffTimer !== null) return;

        const runAutoplayStep = () => {
          if (document.hidden) return;
          scrollByDirection(1);
        };

        // Move once a bit sooner so autoplay feels responsive on initial load.
        const kickoffDelayMs = Math.max(1200, Math.round(autoplayIntervalMs * 0.6));
        autoPlayKickoffTimer = window.setTimeout(() => {
          autoPlayKickoffTimer = null;
          runAutoplayStep();
          autoPlayTimer = window.setInterval(runAutoplayStep, autoplayIntervalMs);
        }, kickoffDelayMs);
      };

      const restartAutoplay = () => {
        stopAutoplay();
        startAutoplay();
      };

      dots.forEach((dot) => {
        dot.addEventListener('click', () => {
          const index = Number.parseInt(dot.dataset.slideTo || '0', 10);
          scrollToSlide(index);
          restartAutoplay();
        });
      });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);
      section.addEventListener('focusin', stopAutoplay);
      section.addEventListener('focusout', (event) => {
        const nextFocusedElement = event.relatedTarget;
        if (nextFocusedElement && section.contains(nextFocusedElement)) return;
        startAutoplay();
      });

      document.addEventListener('visibilitychange', () => {
        if (document.hidden) {
          stopAutoplay();
          return;
        }
        startAutoplay();
      });

      viewport.addEventListener('scroll', syncDots, { passive: true });
      window.addEventListener('resize', syncDots);
      mobileMedia.addEventListener('change', syncViewportHeight);

      syncDots();
      startAutoplay();
    };

    const run = () => {
      document.querySelectorAll('.rotating-banner').forEach(initRotatingBanner);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.rotating-banner');
      if (section) initRotatingBanner(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["social-posts-slider"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      const viewport = section.querySelector('.social-posts-slider__scroll');
      const track = section.querySelector('.social-posts-slider__track');
      const firstCard = section.querySelector('.social-posts-slider__card');
      const prevBtn = section.querySelector('.social-posts-slider__arrow--prev');
      const nextBtn = section.querySelector('.social-posts-slider__arrow--next');

      if (!viewport || !track || !firstCard || !prevBtn || !nextBtn) return;
      if (viewport.dataset.sliderReady === 'true') return;
      viewport.dataset.sliderReady = 'true';

      const getStep = () => {
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      };

      const syncArrows = () => {
        const atStart = viewport.scrollLeft <= 1;
        const atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
      };

      const scrollByStep = (direction) => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const target = viewport.scrollLeft + direction * getStep();
        const clampedTarget = Math.max(0, Math.min(maxScroll, target));
        viewport.scrollTo({ left: clampedTarget, behavior: 'smooth' });
      };

      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (prevBtn.disabled) return;
        scrollByStep(-1);
      });

      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (nextBtn.disabled) return;
        scrollByStep(1);
      });

      viewport.addEventListener('scroll', syncArrows, { passive: true });
      window.addEventListener('resize', syncArrows);
      requestAnimationFrame(syncArrows);
    };

    const run = () => {
      document.querySelectorAll('.social-posts-slider').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.social-posts-slider');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["testimonials"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const initSection = (section) => {
      const viewport = section.querySelector('.testimonials__scroll');
      const track = section.querySelector('.testimonials__track');
      const firstCard = section.querySelector('.testimonials__card');
      const prevBtn = section.querySelector('.testimonials__arrow--prev');
      const nextBtn = section.querySelector('.testimonials__arrow--next');

      if (!viewport || !track || !firstCard || !prevBtn || !nextBtn) return;
      if (viewport.dataset.sliderReady === 'true') return;
      viewport.dataset.sliderReady = 'true';

      const getStep = () => {
        const gap = Number.parseFloat(getComputedStyle(track).gap) || 0;
        return firstCard.getBoundingClientRect().width + gap;
      };

      const scrollByStep = (direction) => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        const target = viewport.scrollLeft + direction * getStep();
        const clampedTarget = Math.max(0, Math.min(maxScroll, target));
        viewport.scrollTo({ left: clampedTarget, behavior: 'smooth' });
      };

      const centerStart = () => {
        const maxScroll = Math.max(0, viewport.scrollWidth - viewport.clientWidth);
        if (maxScroll <= 0) return;
        viewport.scrollLeft = maxScroll / 2;
      };

      const syncArrows = () => {
        const atStart = viewport.scrollLeft <= 1;
        const atEnd = viewport.scrollLeft >= viewport.scrollWidth - viewport.clientWidth - 1;
        prevBtn.disabled = atStart;
        nextBtn.disabled = atEnd;
      };

      prevBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (prevBtn.disabled) return;
        scrollByStep(-1);
      });

      nextBtn.addEventListener('click', (event) => {
        event.preventDefault();
        if (nextBtn.disabled) return;
        scrollByStep(1);
      });

      viewport.addEventListener('scroll', syncArrows);
      requestAnimationFrame(() => {
        centerStart();
        syncArrows();
      });
      syncArrows();
    };

    const run = () => {
      document.querySelectorAll('.testimonials').forEach(initSection);
    };

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', run);
    } else {
      run();
    }

    document.addEventListener('shopify:section:load', (event) => {
      const section = event.target.querySelector('.testimonials');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
